export default __webpack_public_path__ + "static/media/GitBook.6f207aa8.svg";